import type { SxProps, Theme } from '@mui/material/styles';

export const footerStyles: Record<string, SxProps<Theme>> = {
  root: (theme) => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    flexWrap: 'wrap',
    gap: theme.spacing(4),
    paddingInline: { xs: theme.spacing(3), md: theme.spacing(6) },
    paddingBlock: theme.spacing(5),
    backgroundColor: theme.palette.background.default,
    borderTop: `1px solid ${theme.palette.divider}`,
  }),
  brand: {
    display: 'inline-flex',
    alignItems: 'center',
  },
  legalRow: (theme) => ({
    display: 'inline-flex',
    alignItems: 'center',
    gap: theme.spacing(3),
    flexWrap: 'wrap',
  }),
  // Figma (verified via inspector): Space Grotesk Regular 14 / 20, #414651.
  legalLink: (theme) => ({
    fontFamily: theme.typography.button.fontFamily,
    fontWeight: theme.typography.fontWeightRegular,
    fontSize: '0.875rem',
    lineHeight: '1.25rem',
    color: theme.palette.surface.footerText,
  }),
  legalText: (theme) => ({
    fontFamily: theme.typography.button.fontFamily,
    fontWeight: theme.typography.fontWeightRegular,
    fontSize: '0.875rem',
    lineHeight: '1.25rem',
    color: theme.palette.surface.footerText,
  }),
};
